<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Invoices List</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" small text to="/freight/invoices">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" xs="12" md="3">
            <span style="color: red"> Container No: {{ dataItem.Name }}</span
            ><br />
            <span>Date Received: {{ dataItem.DocDate }}</span>
          </v-col>

          <v-col cols="12" xs="12" md="2">
            <span style="color: red"> Total Lines: {{ dataItem.Lines }}</span>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <span>
              Cost / Line:
              {{
                dataItem.LineCost && dataItem.LineCost.toLocaleString()
              }}</span
            >
          </v-col>

          <!-- <v-col cols="12" xs="12" md="2">
            <span
              >Total Value:
              {{ (dataItem.Lines * dataItem.LineCost).toLocaleString() }}</span
            >
          </v-col> -->
        </v-row>

        <!-- manifest list -->
        <v-row>
          <v-col cols="12">
            <!-- start of table -->
            <v-data-table
              :headers="headers"
              :items="manifestData"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- action template -->
              <template v-slot:item.LineCost="{ item }">
                {{ item.LineCost.toLocaleString() }}
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.DocTotal="{ item }">
                {{ item.DocTotal.toLocaleString() }}
              </template>
              <!-- end -->

              <!-- manifest template -->
              <template v-slot:item.invoice="{ item }">
                <v-btn
                  v-if="item.Invoiced == 'N'"
                  color="accent"
                  text
                  @click="openInvoiceDialog(item)"
                  ><v-icon left>mdi-plus</v-icon>
                  Raise Invoice
                </v-btn>

                <v-btn
                  :to="`/view/manifest/invoice/${item.id}`"
                  v-else
                  color="primary"
                  text
                  ><v-icon left>mdi-eye</v-icon>
                  View Invoice
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters(["user"]),
  },
  data: () => ({
    dataItem: {},
    loader: false,
    activeItem: {},
    Description: null,
    search: null,
    invoiceDialog: false,
    manifestData: [],
    docCreate: false,
    headers: [
      { text: "Customer", value: "ocrd.Name" },
      { text: "Phone No.", value: "ocrd.PhoneNumber" },
      { text: "Lines", value: "Lines" },
      //   { text: "Cost / Line", value: "LineCost" },
      { text: "Total", value: "DocTotal" },
      { text: "Action", value: "invoice" },
    ],
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/stores/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.dataItem = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });

      // fetch manifest
      this.$store
        .dispatch("get", `/manifest/invoiced/${val}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.manifestData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>